import React from 'react'
import { Link } from 'gatsby'

// Components
import Image from 'components/shared/ImageGatsby'
import { ScrollRevealItem } from 'components/shared/ScrollReveal'
import Title from 'components/elements/Title'

interface TextWithImageLinksProps {
  // eslint-disable-next-line
  fields: GatsbyTypes.WpPage_Flexcontent_Flex_Text
}

function TextWithImageLinks({ fields }: TextWithImageLinksProps) {
  return (
    <section id={fields?.anchorId || ''}>
      <div className="container py-5">
        <div className="row no-gutters py-lg-5">
          <div className="col-12">
            <Title>{fields?.title}</Title>
          </div>
          {fields?.imageWithLink?.map((image, index) => (
            <ScrollRevealItem
              // eslint-disable-next-line react/no-array-index-key -- CMS order; no stable id
              key={index}
              className="col-lg-4 col-6"
              sequenceIndex={index}
            >
              <Link
                to={image?.link?.url || ''}
                target={image?.link?.target || '_self'}
              >
                <Image
                  image={image?.image}
                  alt={image?.link?.title}
                  loading="lazy"
                />
              </Link>
            </ScrollRevealItem>
          ))}
        </div>
      </div>
    </section>
  )
}

export default TextWithImageLinks
